const getBaseUrl = () => {
  if (window?.location?.origin) {
    var base_url = window.location.origin;

    var apiUrl = `${base_url}/antrian-api`;
    return apiUrl;
  } else {
    return "";
  }
};

const getBaseUrlMedia = () => {
  if (window?.location?.origin) {
    var base_url = window.location.origin;

    var apiUrl = `${base_url}/antrian-api/public/uploads`;
    return apiUrl;
  } else {
    return "";
  }
};

const getBaseUrlRoot = () => {
  if (window?.location?.origin) {
    var base_url = window.location.origin;
    var apiUrl = `${base_url}/antrian-fe`;
    return apiUrl;
  } else {
    return "";
  }
};

// const CONFIG = {
//   URL: getBaseUrl(),
//   URL_MEDIA: getBaseUrlMedia(),
//   URL_ROOT: getBaseUrlRoot(),
// };

const CONFIG = {
  URL_DISDUK: "https://antrian-api.event-ku.com",
  URL_DINSOS: "https://antrian-dinsos-api.event-ku.com",
  URL_MEDIA: "https://antrian-api.event-ku.com/public/",
  URL_ROOT: "https://antrian.event-ku.com",
};

// URL: "https://prestige-api.eventqiu.com/api",
// URL: "http://192.168.100.114/prestige/prestige-api/api",
export default CONFIG;
